import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IsEqualService {
  /**
   * Checks if two values are equal
   * @param value The first value to compare
   * @param other The second value to compare
   * @returns true if the values are equal, false otherwise
   */
  static isEqual(value: any, other: any): boolean {
    // Handle null and undefined
    if (value === other) return true;
    if (value === null || other === null || value === undefined || other === undefined)
      return false;

    // Handle primitive types
    if (typeof value !== 'object' && typeof other !== 'object') return value === other;

    // Handle Date objects
    if (value instanceof Date && other instanceof Date) {
      return value.getTime() === other.getTime();
    }

    // Handle RegExp objects
    if (value instanceof RegExp && other instanceof RegExp) {
      return value.toString() === other.toString();
    }

    // Handle Arrays
    if (Array.isArray(value) && Array.isArray(other)) {
      if (value.length !== other.length) return false;
      return value.every((val, index) => this.isEqual(val, other[index]));
    }

    // Handle Objects
    if (typeof value === 'object' && typeof other === 'object') {
      if (value.constructor !== other.constructor) return false;
      const keys1 = Object.keys(value);
      const keys2 = Object.keys(other);

      if (keys1.length !== keys2.length) return false;

      return keys1.every(
        (key) =>
          Object.prototype.hasOwnProperty.call(other, key) && this.isEqual(value[key], other[key]),
      );
    }

    return false;
  }
}
